import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=b9f395b4&"
var script = {}
import style0 from "./FormError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports